export const personalCosts = [
    {
        name: "Food",
        categories: ['Groceries', 'Restaurants/Takeout']
    },
    {
        name: "Car",
        categories: ['Car Insurance', 'Car Payment', 'Gas', 'Parking', 'Public Transit'],
    },
    {
        name: "Health",
        categories: ['Insurance', 'Copays', 'Prescriptions & Medical Equipment', 'Therapy', 'Childcare'],
    },
    {
        name: 'Debt',
        categories: ['Personal Loans', 'Student Loans', 'Credit Card Payments'],
    },
    {
        name: 'Housing',
        categories: ['Rent', 'Deposit'],
    },
    {
        name: 'Bills',
        categories: ['Electricity', 'Gas', 'Water', 'Phone/mobile', 'Internet', 'Cable'],
    },
    {
        name: "Clothing",
        categories: ['Adults', 'Children', 'Cleaning & laundry']
    }
];

export const relocationCosts = [
    {
        name: "Career",
        categories: ["Income Loss", "Job Training & Professional Development", "Miscellaneous Fees"]
    },
    {
        name: "Housing",
        categories: ["Hotel Expenses", "Housing Deposit", "Utilities Deposits", "Rent", "Miscellaneous Fees"]
    },
    {
        name: "Transportation",
        categories: ["Car Rental", "Moving Truck Rental", "Gas", "Airline/Bus Tickets"]
    },
    {
        name: "Miscellaneous",
        categories: ["Storage Unit", "Furniture & Appliances", "Pet Expenses", "Cell Phone Disconnection Fees", "Additional Security Measures"]
    }
];